import { Outlet, useLocation } from 'react-router-dom';
import { useEffect, useLayoutEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const MainLayout = () => {
  const location = useLocation();

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useLayoutEffect(() => {
    // The global smooth-scroll rule would animate this, so force an instant reset.
    const root = document.documentElement;
    const previous = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    window.scrollTo(0, 0);
    root.style.scrollBehavior = previous;
  }, [location.pathname, location.search]);

  return (
    <div className="tl-layout">
      <Header />
      <main className="tl-main">
        <Outlet />
      </main>
      <Footer showCta={location.pathname === '/' || location.pathname === '/about'} />
    </div>
  );
};

export default MainLayout;
